// extracted by mini-css-extract-plugin
module.exports = {"Container":"PlayerBoardControl_Container__ChsJD"};